import React from 'react'
import { useSiteMetadata } from '../hooks/useSiteMetadata'

type PageTemplateProps = {
    title?: string
    description?: string
    pathname?: string
    children?: React.ReactNode
}
export const Seo = ({ title, description, pathname, children }: PageTemplateProps) => {
    const { title: defaultTitle, description: defaultDescription, image, siteUrl } = useSiteMetadata()

    const seo = {
        title: title || defaultTitle,
        description: description || defaultDescription,
        image: `${siteUrl}${image}`,
        url: `${siteUrl}${pathname || ``}`,
    }

    return (
        <>
            <title>{seo.title}</title>
            <meta name="description" content={seo.description} />
            <meta name="image" content={seo.image} />

            <meta property="og:title" content={`${seo.title} | InterNations`} />
            <meta property="og:url" content={`${seo.url}`} />
            <meta property="og:image" content={`${seo.image}`} />
            <meta property="og:description" content={`${seo.description}`} />
            <meta property="og:type" content="website" />

            {children}
        </>
    )
}
